import { Typography } from 'antd'

import { FormBlock } from '@eastcoal/formily/components/FormBlock'
import { SchemaItem } from '@eastcoal/formily/components/SchemaForm/interface'

import { basicSchema } from './basic'
import { descriptionSchema } from './description'
import { pictureSchema } from './picture'
import { quotaSchema } from './quota'

export const inquiryAuctionSchema: SchemaItem[] = [
  {
    type: 'void',
    'x-component': FormBlock,
    'x-component-props': {
      collapsible: false,
      headerBordered: true
    },
    properties: {
      basicPanel: {
        type: 'void',
        title: (
          <Typography.Title level={5} style={{ color: '#0E42D2' }}>
            基本信息
          </Typography.Title>
        ),
        'x-component': FormBlock.Panel,
        'x-component-props': {
          id: 'basicPanel'
        },
        properties: basicSchema
      },
      quotaPanel: {
        type: 'void',
        title: (
          <Typography.Title level={5} style={{ color: '#0E42D2' }}>
            指标信息
          </Typography.Title>
        ),
        'x-component': FormBlock.Panel,
        'x-component-props': {
          id: 'quotaPanel'
        },
        properties: quotaSchema
      },
      descriptionPanel: {
        type: 'void',
        title: (
          <Typography.Title level={5} style={{ color: '#0E42D2' }}>
            声明信息
          </Typography.Title>
        ),
        'x-component': FormBlock.Panel,
        'x-component-props': {
          id: 'descriptionPanel'
        },
        properties: descriptionSchema
      },
      picturesPanel: {
        type: 'void',
        title: (
          <Typography.Title level={5} style={{ color: '#0E42D2' }}>
            图片信息
          </Typography.Title>
        ),
        'x-component': FormBlock.Panel,
        'x-component-props': {
          id: 'picturesPanel'
        },
        properties: pictureSchema
      }
    }
  }
]
